<b>{{ value | currency:'ILS':'symbol':'1.0-0' }}</b>